/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SkuCompositionResVo } from './SkuCompositionResVo';
import {
    SkuCompositionResVoFromJSON,
    SkuCompositionResVoFromJSONTyped,
    SkuCompositionResVoToJSON,
    SkuCompositionResVoToJSONTyped,
} from './SkuCompositionResVo';

/**
 * 
 * @export
 * @interface ResponseSkuCompositionResVo
 */
export interface ResponseSkuCompositionResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseSkuCompositionResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseSkuCompositionResVo
     */
    message?: string;
    /**
     * 
     * @type {SkuCompositionResVo}
     * @memberof ResponseSkuCompositionResVo
     */
    data?: SkuCompositionResVo;
}

/**
 * Check if a given object implements the ResponseSkuCompositionResVo interface.
 */
export function instanceOfResponseSkuCompositionResVo(value: object): value is ResponseSkuCompositionResVo {
    return true;
}

export function ResponseSkuCompositionResVoFromJSON(json: any): ResponseSkuCompositionResVo {
    return ResponseSkuCompositionResVoFromJSONTyped(json, false);
}

export function ResponseSkuCompositionResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSkuCompositionResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : SkuCompositionResVoFromJSON(json['data']),
    };
}

export function ResponseSkuCompositionResVoToJSON(json: any): ResponseSkuCompositionResVo {
    return ResponseSkuCompositionResVoToJSONTyped(json, false);
}

export function ResponseSkuCompositionResVoToJSONTyped(value?: ResponseSkuCompositionResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': SkuCompositionResVoToJSON(value['data']),
    };
}

